/* eslint-disable react/react-in-jsx-scope */
const ViewHtml = ({html}) => {
    return <div dangerouslySetInnerHTML={{__html: html}} />;
};
export default ViewHtml;
